import styled from 'styled-components'

export const ActionContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 30px;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
`

export const ActionText = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  letter-spacing: 0.05em;
  text-align: center;
  color: #000;
`
